export const rulesLookupFieldDropdown =  [
	{
	  title: "By Product Sku",
	  value: "Sku"
	},
	{
	  title: "By Channel",
	  value: "OrderType"
	},
	{
	  title: "By POS Location",
	  value: "PosLocation"
	}
];



// WEBPACK FOOTER //
// ./src/pages/orderHoldRules/filter/rulesLookupFieldDropdown.js